import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageBrandDetail } from "@components/modules/brands/detail/PageBrandDetail";
import { NavigationBrand } from "@components/widgets/AppSubNav/NavigationBrand";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Brand detail`}
    navigation={<NavigationBrand id={id} variant="panel" />}
  >
    <PageBrandDetail />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/brands/detail")({
  component: RouteComponent,
});
